import { AxiosInstance } from "axios";
import axiosBase from "./base";

class AboutService {
  base: AxiosInstance;

  constructor() {
    this.base = axiosBase.base;
  }
  getDecisions(page = 1, pageSize = 1000): Promise<any[]> {
    return new Promise(async (resolve, reject) => {
      this.base
        .get(
          `decisions?populate[documents][populate]=attached_document&pagination[page]=${page}&pagination[pageSize]=${pageSize}`
        )
        .then(({ data }) => {
          return resolve(data);
        })
        .catch((err) => reject(err));
    });
  }
  getAuthorisations(): Promise<any[]> {
    return new Promise(async (resolve, reject) => {
      this.base
        .get(`authorizations?populate[documents][populate]=attached_document`)
        .then(({ data }) => {
          return resolve(data);
        })
        .catch((err) => reject(err));
    });
  }
  getConsultations(page = 1, pageSize = 600): Promise<any> {
    return new Promise(async (resolve, reject) => {
      this.base
        .get(
          `consultations?populate[documents][populate]=attached_document&pagination[page]=${page}&pagination[pageSize]=${pageSize}`
        )
        .then(({ data }) => {
          return resolve(data);
        })
        .catch((err) => reject(err));
    });
  }
  getOrders(): Promise<any[]> {
    return new Promise(async (resolve, reject) => {
      this.base
        .get(`orders?populate[documents][populate]=attached_document&pagination[pageSize]=5000&sort=date:DESC`)
        .then(({ data }) => {
          return resolve(data);
        })
        .catch((err) => reject(err));
    });
  }
}
const aboutService = new AboutService();
export default aboutService;
